(function () {
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    document.querySelectorAll('.muiha-tilt-card').forEach(function (card) {
      card.addEventListener('touchstart', function () {
        card.style.transform = 'scale(0.97)';
        card.style.transition = 'transform 0.15s ease';
      }, { passive: true });
      card.addEventListener('touchend', function () {
        card.style.transform = '';
      }, { passive: true });
    });
    return;
  }

  function initTilt(container) {
    if (!container || container.dataset.muihaTilt === 'false') return;
    var intensity = parseFloat(container.dataset.tiltIntensity) || 10;
    var scale     = parseFloat(container.dataset.tiltScale)     || 1.03;
    var cards     = container.querySelectorAll('.muiha-tilt-card');

    cards.forEach(function (card) {
      card.style.willChange = 'transform';
      var rafId = null;

      card.addEventListener('mouseenter', function () {
        card.style.transition = 'transform 0.09s ease';
      });

      card.addEventListener('mousemove', function (e) {
        if (rafId) return;
        var cx = e.clientX, cy = e.clientY;
        rafId = requestAnimationFrame(function () {
          var rect = card.getBoundingClientRect();
          var nx = (cx - rect.left  - rect.width  / 2) / (rect.width  / 2);
          var ny = (cy - rect.top   - rect.height / 2) / (rect.height / 2);
          card.style.transform =
            'perspective(720px) rotateX(' + (-ny * intensity) + 'deg) rotateY(' + (nx * intensity) + 'deg) scale(' + scale + ')';
          rafId = null;
        });
      });

      card.addEventListener('mouseleave', function () {
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        card.style.transition = 'transform 0.55s cubic-bezier(0.23,1,0.32,1)';
        card.style.transform  = 'perspective(720px) rotateX(0deg) rotateY(0deg) scale(1)';
      });
    });
  }

  document.querySelectorAll('[data-muiha-tilt]').forEach(initTilt);

  document.addEventListener('shopify:section:load', function (e) {
    var g = e.target.querySelector('[data-muiha-tilt]');
    if (g) initTilt(g);
  });
})();
